import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { AppRoutingModule } from './app-routing.module';
import { ProfimaskeBaseModule } from '@base/profimaske-base.module';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';

import { RouterModule, Routes } from '@angular/router';

import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';

@NgModule({
  declarations: [
    AppComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProfimaskeBaseModule.forRoot(),
   environment.production ? [] : AkitaNgDevtools.forRoot()
  ],
  providers: [
    { provide: NG_ENTITY_SERVICE_CONFIG, useValue: { baseUrl: environment.server } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
